// extracted by mini-css-extract-plugin
module.exports = {"blink":"blink___3KbSn"};